export const localStorageAccessKey = '__auth_provider_access__';
export const localStorageResourcesAccessKey = '__auth_resources_access__';
export const rolesAndPermissionsTabsAccessKey = 'roles_and_permissions_tabs';
export const localStorageTimeOffPlanSettingsKey = '__timeOffPlanSettingsKey__';

export const YA_ME_INTERNAL_SYSTEM_CODE = 'ya-me';
export const PAYMENTS_INTERNAL_SYSTEM_CODE = 'payments';
export const CEP_INTERNAL_SYSTEM_CODE = 'cep';
export const ERP_INTERNAL_SYSTEM_CODE = 'erp';
export const CEP_VIEWER_ROLES_ID = '7bca3ade-0772-4aef-8f38-631b0a1694c9';

export const ASSOCIATES_YA_ME_PAGE_KEY = 'associates_ya_me_page_key';

export enum RequestStatus {
  in_progress = 'in_progress',
  approved = 'approved',
  declined = 'declined',
  new = 'new',
  canceled = 'canceled',
}

export enum CompensationRequestStatus {
  in_progress = 'in_progress',
  approved = 'approved',
  declined = 'declined',
  new = 'new',
  needs_update = 'needs_update',
}

export enum ResolutionStatus {
  in_progress = 'in progress',
  approved = 'approved',
  declined = 'declined',
  canceled = 'canceled',
}

export const durationLabel = {
  HalfDay: '4h',
  Day: '8h',
} as const;

export const requestStatusLabelOptions = {
  in_progress: 'in progress',
  approved: 'approved',
  declined: 'declined',
  new: 'new',
} as const;

export const monthsFullForm = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const monthsShortForm = monthsFullForm.map((m) => m.slice(0, 3));

export const WORKING_HOURS_OF_THE_DAY = 8;

export const archivedStatusLabelOptions = {
  Active: 'Active',
  Archived: 'Archived',
} as const;

export const sourceOfChangedTooltipText = {
  erp: 'Can be edited in ERP',
  cep: 'Can be edited in CEP',
} as const;

export const timeOffTypeAction = {
  Add: 'deposit',
  Remove: 'withdraw',
} as const;

interface PermissionsType {
  ERP: 'erp';
  YA_ME: 'ya-me';
  CEP: 'cep';
  PAYMENTS: 'payments';
  MC: 'mc';
}

export const APPS_PERMISSIONS: PermissionsType = {
  ERP: 'erp',
  YA_ME: 'ya-me',
  PAYMENTS: 'payments',
  CEP: 'cep',
  MC: 'mc',
};

export enum COMPANY {
  yalantis = 'yalantis',
  sherp = 'sherp',
  temy = 'temy',
  sab = 'sab',
  tallium = 'tallium',
  artkai = 'artkai',
  boostylabs = 'boostylabs',
  linkupst = 'linkupst',
}
